/**
 * @generated SignedSource<<11c6e434a18b40f89934f7d45ec7d636>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type esqueciASenha_forgotPasswordMutation$variables = {
  club: string;
  email: string;
};
export type esqueciASenha_forgotPasswordMutation$data = {
  readonly forgotPassword: boolean;
};
export type esqueciASenha_forgotPasswordMutation = {
  response: esqueciASenha_forgotPasswordMutation$data;
  variables: esqueciASenha_forgotPasswordMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "club"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "email"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "club",
        "variableName": "club"
      },
      {
        "kind": "Variable",
        "name": "username",
        "variableName": "email"
      }
    ],
    "kind": "ScalarField",
    "name": "forgotPassword",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "esqueciASenha_forgotPasswordMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "esqueciASenha_forgotPasswordMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "dd4614079d13f799813958cee6900662",
    "id": null,
    "metadata": {},
    "name": "esqueciASenha_forgotPasswordMutation",
    "operationKind": "mutation",
    "text": "mutation esqueciASenha_forgotPasswordMutation(\n  $club: String!\n  $email: String!\n) {\n  forgotPassword(username: $email, club: $club)\n}\n"
  }
};
})();

(node as any).hash = "ceb37acfc2cfb1823e14b96571aa63b8";

export default node;
